import React, { FunctionComponent } from 'react';
import { Presentation } from './presentation';

type Props = {
  mainTitle: string;
  penIconImg: string;
  personId: number;
  fromPage: string;
  resume: "" | File | { name: { url: string; } };
  resumeUpdatedAt?: string;
  job_resume: "" | File | { name: { url: string; } };
  jobResumeUpdatedAt?: string;
  isShow: boolean;
  isStudent: boolean;
  isNotRequestedResume: boolean;
  isNotRequestedJobResume: boolean;
  handleOpenModal: (target: string, title: string) => void;
  handleRequestResume: (type: string) => void;
  isOneYearPassed: boolean;
};

export const Component: FunctionComponent<Props> = ({
  mainTitle,
  penIconImg,
  personId,
  fromPage,
  resume,
  resumeUpdatedAt,
  job_resume,
  jobResumeUpdatedAt,
  isShow,
  isStudent,
  isNotRequestedResume,
  isNotRequestedJobResume,
  handleOpenModal,
  handleRequestResume,
  isOneYearPassed,
}) => {
  const handleClick = (target: string, title: string) => {
    handleOpenModal(target, title);
  };

  const handleRequestResumeClick = (type: string) => {
    handleRequestResume(type);
  };

  const shouldDisplaySection = () => {
    return !(resume === '' && job_resume === '' && !isShow && fromPage !== 'companyShow');
  };

  const shouldDisplay = (value: any) => {
    if (value === '' || value === undefined) {
      return isShow || fromPage === 'companyShow';
    }
    return true;
  };

  return (
    <Presentation
      mainTitle={mainTitle}
      penIconImg={penIconImg}
      resume={resume}
      job_resume={job_resume}
      resumeUpdatedAt={resumeUpdatedAt}
      jobResumeUpdatedAt={jobResumeUpdatedAt}
      isShow={isShow}
      isStudent={isStudent}
      personId={personId}
      isNotRequestedResume={isNotRequestedResume}
      isNotRequestedJobResume={isNotRequestedJobResume}
      shouldDisplaySection={shouldDisplaySection()}
      shouldDisplay={shouldDisplay}
      isOneYearPassed={isOneYearPassed}
      handleClick={handleClick}
      handleRequestResumeClick={handleRequestResumeClick}
    />
  );
};
